<template>
  <div class="header">
    <div class="homeTitle">
		在线考试系统
	<p class="lisb">如果因正常考试流程验证来到此页面，说明某个验证环节出现异常，请点击 <a href="/exam/">重新验证</a> 进入考试。</p>
	</div>

  </div>
</template>

<script>

export default {
  name: 'Header',
  data () {
    return {
      theme1: 'light'
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./index";

.header {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1000;
  font-size: 14px;
}
.homeTitle {
  position: absolute;
  top: 50%;
  text-align: center;
  font-size: 60px;
  width: 600px;
  left: 50%;
  margin-left: -300px;
  height: 80px;
  margin-top: -80px;
  font-weight: 600;
}
.lisb{
	text-align: center;
	font-size: 14px;
	font-weight: 500;
	a{
		text-decoration: solid;
		color: #1890FF;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue